import { PlusOutlined } from '@ant-design/icons';
import { FormHandler, RelationEditor } from '@framework/form';
import { Drawer, DrawerButtonRow } from '@framework/ui';
import { Button, Space, message } from 'antd';
import * as React from 'react';
import { IMapLayer, MapLayerType } from '../layers/MapLayer';
import { MapLayerSchema } from '../layers/MapLayerSchema';
import { MapLayerConfigInput } from './MapLayerConfigInput';

export interface IMapLayerConfigDrawerButtonProps {
  editor: RelationEditor<IMapLayer>;
  allowedTypes?: MapLayerType[];
}

export function MapLayerConfigDrawerButton(
  props: IMapLayerConfigDrawerButtonProps,
) {
  const { editor, allowedTypes } = props;
  return (
    <div>
      <Button
        type="dashed"
        block
        size="large"
        icon={<PlusOutlined aria-hidden="true" />}
        onClick={e => {
          editor.handle.open(
            MapLayerSchema.cast({ type: MapLayerType.OSM }, { assert: false }),
          );
          e.stopPropagation();
        }}
      >
        Aggiungi Livello
      </Button>
      {/* Modal Drawer  */}
      <Drawer
        title={editor.handle.isNew ? 'Crea Livello' : 'Modifica Livello'}
        size="large"
        placement="right"
        onClose={editor.handle.cancel}
        open={editor.handle.isVisible}
      >
        <FormHandler
          nested
          layout="vertical"
          schema={MapLayerSchema}
          initialValues={
            editor.handle.current ??
            MapLayerSchema.cast({ type: MapLayerType.OSM }, { assert: false })
          }
          onSubmit={async (values, e) => {
            try {
              const type = editor.handle.apply(values);
              if (type === 'updated') {
                message.success('Livello modificato');
              } else {
                message.success('Livello aggiunto');
              }
            } catch (e) {
              message.error(
                'Si è verificato un errore nella modifica del livello',
              );
              console.error(e);
            }
          }}
        >
          <MapLayerConfigInput name={''} allowedTypes={allowedTypes} />

          <DrawerButtonRow>
            <Space>
              <Button size="large" onClick={editor.handle.cancel}>
                Annulla
              </Button>
              <Button type="primary" htmlType="submit" size="large">
                Applica
              </Button>
            </Space>
          </DrawerButtonRow>
        </FormHandler>
      </Drawer>
    </div>
  );
}
